module.exports = __webpack_public_path__ + "static/img/img1.468bd8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/img1.png
// module id = HyQc
// module chunks = 1